export default Object.freeze({
  Engine: 'engine',
  ApiServer: 'api-server',
  ChatApiServer: 'chat-api-server',
  DataApiServer: 'data-api-server',
  ExternalSystemProvider: 'external-system-provider',
  AutomyAgent: 'automy-agent',
  ExternalUser: 'external-user',
  AutomyProcessPortal: 'automy-process-portal',
  AutomyApp: 'automy-app',
  AutomySite: 'automy-site',
  SuperAdmin: 'super-admin',
  Owner: 'owner',
  Admin: 'admin',
  BillingAdmin: 'billing-admin',
  CommercialAdmin: 'commercial-admin',
  UserAdmin: 'user-admin',
  Support: 'support',
  Auditor: 'auditor',
  Partner: 'partner',
  Collaborator: 'collaborator',
  User: 'user',
  Guest: 'guest',
});
